import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import DataTableContext from "./DataTableContext";
import { TableCell, TableHead, TableRow } from "../Table";
import Text from "../Text/Text";

var DataTableHead = function DataTableHead(props) {
  var className = props.className,
      columns = props.columns,
      remaining = _objectWithoutProperties(props, ["className", "columns"]);

  var classes = classNames('DataTableHead', className);
  var columnsRender = columns.filter(Boolean).map(function (child, i) {
    var alignValue = 'flex-start';

    if (child.align === 'center') {
      alignValue = 'center';
    } else if (child.align === 'right') {
      alignValue = 'flex-end';
    }

    return /*#__PURE__*/React.createElement(DataTableContext.Consumer, {
      key: i
    }, function (_ref) {
      var size = _ref.size;
      var paddingValue = size === 'small' ? 4 : 8;
      var textLineHeightValue = size === 'small' ? 16 : 20;
      var textSizeValue = size === 'small' ? 11 : 13;
      return /*#__PURE__*/React.createElement(TableCell, {
        className: "DataTableHead-cell",
        "data-test": child.test,
        align: child.align,
        wrap: false,
        vAlign: "middle",
        width: child.width,
        colSpan: child.colSpan
      }, /*#__PURE__*/React.createElement(Box, {
        flex: {
          alignItems: 'center',
          justifyContent: alignValue
        },
        padding: paddingValue
      }, /*#__PURE__*/React.createElement(Text, {
        color: "dark",
        lineHeight: textLineHeightValue,
        size: textSizeValue,
        typeface: "upper",
        weight: "medium",
        wrap: false
      }, child.label)));
    });
  });
  return /*#__PURE__*/React.createElement(TableHead, _extends({}, remaining, {
    className: classes
  }), /*#__PURE__*/React.createElement(TableRow, {
    className: "DataTableHead-row"
  }, columnsRender));
};

export default DataTableHead;